import { CellContext, createColumnHelper } from '@tanstack/react-table';
import { compact } from 'lodash';

import { formatDate } from '@/portainer/filters/filters';

import { Link } from '@@/Link';

import { CustomResource } from '../types';

import { actions } from './columns/actions';

const columnHelper = createColumnHelper<CustomResource>();

export function createColumns(isNamespaced: boolean) {
  return compact([
    columnHelper.accessor('name', {
      id: 'name',
      header: 'Name',
      cell: ({ getValue, row }: CellContext<CustomResource, string>) => {
        const name = getValue();
        const { namespace, definitionName } = row.original;
        return (
          <Link
            to="kubernetes.moreResources.customResource"
            params={{ name, namespace, definition: definitionName }}
            data-cy={`cr-name-link-${name}`}
          >
            {name}
          </Link>
        );
      },
    }),
    isNamespaced &&
      columnHelper.accessor('namespace', {
        id: 'namespace',
        header: 'Namespace',
        cell: ({
          getValue,
        }: CellContext<CustomResource, string | undefined>) => {
          const namespace = getValue();
          return namespace || '-';
        },
      }),
    columnHelper.accessor('definitionName', {
      id: 'definition',
      header: 'Definition Name',
      cell: ({ getValue }: CellContext<CustomResource, string>) => getValue(),
    }),
    columnHelper.accessor('creationDate', {
      id: 'created',
      header: 'Created',
      cell: ({ getValue }: CellContext<CustomResource, string>) =>
        formatDate(getValue()),
    }),
    actions,
  ]);
}
